import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import Tooltip from 'rc-tooltip'
import format from 'date-fns/format'
import TimestampActions from '../redux/timestampRedux'
import TimeSliderActions from '../redux/timeSliderRedux'
import { getCombinedTimestamps } from '../selectors/combinedTimestampsSelector'
import { getGeneratedMarks } from '../selectors/generatedMarksSelector'
import isEmptyObject from '../utility/isEmptyObject'

const styles = theme => ({
  empty: {
    height: '100%'
  }
})

const formatTime = timestamp => {
  return format(new Date(timestamp || null), 'do MMMM yyyy')
}

const Handle = Slider.Handle

const handle = props => {
  const { value, dragging, index, ...restProps } = props

  return (
    <Tooltip
      prefixCls='rc-slider-tooltip'
      overlay={formatTime(value)}
      visible={dragging}
      placement='left'
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  )
}

class SliderDatetimeVertical extends PureComponent {
  constructor (props) {
    super(props)
    const { actions, combinedTimestamps, generatedMarks } = props

    const minValue = new Date(combinedTimestamps[0]).getTime()
    const maxValue = new Date(
      combinedTimestamps[combinedTimestamps.length - 1]
    ).getTime()
    const value = maxValue

    actions.timeSliderInitialized(generatedMarks, minValue, maxValue, value)
    actions.timeSliderValueUpdated(maxValue)
  }

  componentWillReceiveProps (nextProps) {
    const { actions, combinedTimestamps, generatedMarks } = nextProps
    if (combinedTimestamps !== this.props.combinedTimestamps) {
      const minValue = new Date(combinedTimestamps[0]).getTime()
      const maxValue = new Date(
        combinedTimestamps[combinedTimestamps.length - 1]
      ).getTime()
      const value = maxValue

      actions.timeSliderInitialized(generatedMarks, minValue, maxValue, value)
    }
  }

  handleChange = timestamp => {
    const { actions } = this.props

    actions.timeSliderValueUpdated(timestamp)
  }

  render () {
    const {
      classes,
      defaultValue = 0,
      generatedMarks,
      value,
      hidden
    } = this.props

    if (hidden) {
      return (
        null
      )
    }
    const marks = generatedMarks

    if (isEmptyObject(marks)) {
      return <div className={classes.empty} />
    }
    if (Object.keys(marks).length < 2) {
      return <div className={classes.empty} />
    }

    const markValues = Object.keys(marks)
    const minMarkValue = parseInt(markValues[0], 10)
    const maxMarkValue = parseInt(markValues[markValues.length - 1], 10)

    return (
      <Slider
        vertical
        className={classes.slider}
        railStyle={{ width: 4 }}
        marks={marks}
        min={minMarkValue}
        max={maxMarkValue}
        step={null}
        included={false}
        onChange={this.handleChange}
        defaultValue={defaultValue}
        handle={handle}
        value={value}
        />
    )
  }
}

const mapStateToProps = state => {
  return {
    combinedTimestamps: getCombinedTimestamps(state),
    generatedMarks: getGeneratedMarks(state),
    allTimestamps: state.timestamp.timestamps,
    marks: state.timeSlider.marks,
    minValue: state.timeSlider.minValue,
    maxValue: state.timeSlider.maxValue,
    value: state.timeSlider.value
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      setNewTimeRequested: (timestamp, layerName) =>
        dispatch(TimestampActions.setNewTimeRequested(timestamp, layerName)),
      timeSliderValueUpdated: value =>
        dispatch(TimeSliderActions.timeSliderValueUpdated(value)),
      timeSliderInitialized: (marks, minValue, maxValue, value) =>
        dispatch(
          TimeSliderActions.timeSliderInitialized(
            marks,
            minValue,
            maxValue,
            value
          )
        )
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SliderDatetimeVertical)
)



// WEBPACK FOOTER //
// ./src/components/SliderDatetimeVertical.js